<template>
  <div class="w-screen relative border mt-8 left-[50%] right-[50%] ml-[-50vw] mr-[-50vw]">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="relative bg-white py-8">
        <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
          <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <IconBox icon="far fa-coins " title="Günstig"
                     description="Wir bieten Ihnen die günstigste Kautionsbürgschaft in Deutschland an – ab nur 3,25 € pro Monat."/>
            <IconBox icon="far fa-rabbit-fast " title="Superschnell"
                     description="Den Prozess der Mietsicherheit schnell über die Bühne bringen? Check! Nach
                       erfolgreichem Abschluss landet Ihre digitale Urkunde nur wenige Minuten später in Ihrem
                       E-Mail-Postfach. Parallel senden wir die Urkunde zum Download an Ihren Vermieter."/>
            <IconBox icon="far fa-map-signs " title="100 % digital &amp; nachhaltig" description="Heysafe ist
                        Deutschlands erste grüne Kautionsbürgschaft – papierlos und komplett digital. Damit steht alles
                        im Fokus der Nachhaltigkeit."/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconBox from "./IconBox";
</script>
